import { DateAdapter, MatDateFormats } from '@angular/material'
export class TellowConstants {
  static getRoles() {
    return [
      { value: 'ROLE_USER', name: 'USER.USER', filter: 'USER' },
      { value: 'ROLE_ADMIN', name: 'USER.ADMIN', filter: 'ADMIN' },
      { value: 'ROLE_REVIEW', name: 'USER.REVIEWER', filter: 'REVIEWER' },
    ]
  }

  static getStatus() {
    return [
      { value: '1', name: 'USER.PROSPECT', filter: 'PROSPECT' },
      { value: '2', name: 'USER.ACTIVE', filter: 'ACTIVE' },
      { value: '3', name: 'USER.BLOCKED', filter: 'BLOCKED' },
      { value: '4', name: 'USER.INVITED', filter: 'INVITED' },
    ]
  }

  static getGenders() {
    return [
      { value: 'MALE', name: 'MALE' },
      { value: 'FEMALE', name: 'FEMALE' },
      { value: 'PERSON', name: 'PERSON' },
    ]
  }

  static getDocumentStates() {
    return [
      { value: 'IN_PROGRESS', name: 'IN_PROGRESS' },
      { value: 'PROCESSED', name: 'PROCESSED' },
      { value: 'REJECTED', name: 'REJECTED' },
    ]
  }
  static getReasons() {
    return [
      { value: 'REJECTED_BEFORE_START_DATE', name: 'REJECTED_BEFORE_START_DATE' },
      { value: 'REJECTED_DUPLICATE', name: 'REJECTED_DUPLICATE' },
      { value: 'REJECTED_INVOICE_MANUAL_DELETED', name: 'REJECTED_INVOICE_MANUAL_DELETED' },
      { value: 'REJECTED_NO_INVOICE', name: 'REJECTED_NO_INVOICE' },
      { value: 'REJECTED_NOT_READABLE', name: 'REJECTED_NOT_READABLE' },
      { value: 'REJECTED_OTHERS', name: 'REJECTED_OTHERS' },
      { value: 'REJECTED_PURCHASE_AS_SALES', name: 'REJECTED_PURCHASE_AS_SALES' },
      { value: 'REJECTED_SALES_AS_PURCHASE', name: 'REJECTED_SALES_AS_PURCHASE' },
      { value: 'DOCUMENT_UPLOADED_SUCCESSFUL', name: 'DOCUMENT_UPLOADED_SUCCESSFUL' },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/enums/TellowConstants.ts